/** HTML `#app-boot-splash` — keep until the first real screen is ready (avoids logo double-flash). */

export function removeBootSplash(): void {
  try {
    document.getElementById('app-boot-splash')?.remove();
  } catch {
    /* ignore */
  }
}

/** Paths that dismiss the boot splash themselves once their UI is ready. */
export function shouldKeepBootSplash(): boolean {
  try {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    return path === '/crm-login' || path === '/sales-crm';
  } catch {
    return false;
  }
}
